export default {
  eyebrow: '404 | 迷路了',
  title: '您访问的页面不存在',
  description: '抱歉，您要访问的地址不存在或已被移除。请返回首页，或回到刚才的页面继续浏览。',
  actions: {
    home: '返回首页',
    back: '回到上一页',
  },
};
